import { CourseService } from "@/common/api.service";
import { FETCH_COURSES, COURSE_SUBSCRIBE,RESET_STATE } from "./actions.type";
import { SET_COURSES, SET_ERROR,STATE_RESET } from "./mutations.type";

const initialState = () => {
    return {
        courses: [],
        courseerrors:[],
    }
}

let state = initialState()

const getters = {
    courses(state) {
        return state.courses
    }
}

const actions = {
    async [FETCH_COURSES](context, slug) {
        const { data } = await CourseService.get(slug)
        context.commit(SET_COURSES, data.data)
        return data;
    },
    async [COURSE_SUBSCRIBE](context,courseid){
        return CourseService.subscribe(courseid)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, error.response.data.errors)
        });
    },

    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_COURSES](state, coursedata) {
        state.courses = coursedata
    },
    [SET_ERROR](state, error) {
        state.courseerrors = error;
    },  
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};

